import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";


const Customer = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    let response30 = useInvoke("WebApps", "30", {});

    useEffect(() => {

        //get customers
        if (response30.data.payload != undefined) {
            let myData = JSON.parse(response30.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "link", content: {text: `${entry[1]}`, link: `/customer/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[2]}`}},
                {type: "text", content: {text: `${entry[3]}`}},
                {type: "text", content: {text: `${entry[4]}`}},
                {type: "text", content: {text: `${entry[5]}`}},
                {type: "text", content: {text: `${entry[6]}`}},
              ];
              rowsList.push(row);
            });
            setColumns(["Customer Name", "Abbr", "Address", "City", "State", "Zip"]);
            setRows(rowsList);
        }

    }, [response30.data.payload]);

    document.title = "Customers";
    return ( 
        <div className="customer">
            {user["email"] != undefined &&
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Customers</h2>
                        {/* <p><Link className="btn btn-primary" to="/Customer/New">New Customer</Link></p> */}
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>
                </>
            }
        </div>
     );
}
 
export default Customer;